/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRentDto } from '../../models/backend-rent-dto';
import { BackendRentRequestDto } from '../../models/backend-rent-request-dto';

export interface OpexesRentCreate$Params {
  body: BackendRentRequestDto;
}

export function opexesRentCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesRentCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRentDto>> {
  const rb = new RequestBuilder(rootUrl, opexesRentCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRentDto>;
    }),
  );
}

opexesRentCreate.PATH = '/api/opexes/rent/';
